import React from 'react'
import { useTranslation } from "react-i18next";
import {DECIMAL_NUMBER_2} from "../../utils/NumberUtils";
import Input from "./Input";


function CalculatedPrices(props) {
  const { t } = useTranslation();

  return (
    <div className=" pb-3">
      <span>{props.title}</span>
        <div className="has-tooltip primary" data-tooltip={props.price.error ? "" : props.priceFormula }>
          <Input
            type="number"
            numberFormat={DECIMAL_NUMBER_2}
            formatDecimalNumber={true}
            unit="€"
            label={props.label ? props.label : t('total_price')}
            formField={props.price}
            disabled={props.disabled}
          />
      </div>
    </div>
  )
}

export default CalculatedPrices;
